import { USER_ROLES } from "UTILS/Constants";

export const getShowInboundCoBrowse = (state) => {
  return state.InboundCoBrowseReducer.showInboundCoBrowse;
};

export const setEndInboundCoBrowse = (state) => {
  return state.InboundCoBrowseReducer.endInboundCoBrowse;
};

export const setIsInboundCobrowseMinimize = (state) => {
  return state.InboundCoBrowseReducer.isInboundCobrowseMinimize;
};